export const environment = {
  production: false,
  api: 'https://devservices.sequation.net',
  enableCtrl: true,
  azureBlobStorage: 'https://sequationdevsav2.blob.core.windows.net'
};
